import { Checklist } from '../Checklist'
import { useKitchensink } from '../context'
import { theme } from '../theme'

export const PageA = () => {
  const { variant } = useKitchensink()

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '6px' }}>
        <span
          style={{
            fontSize: '10px',
            fontWeight: 700,
            color: theme.accent,
            textTransform: 'uppercase',
            letterSpacing: '0.1em',
            backgroundColor: theme.accentSubtle,
            padding: '3px 8px',
            borderRadius: '4px',
          }}
        >
          Course 1
        </span>
      </div>

      <h1
        style={{
          fontSize: '24px',
          fontWeight: 700,
          color: theme.text,
          margin: '0 0 6px',
          letterSpacing: '-0.02em',
        }}
      >
        🥩 The First Cut
      </h1>
      <p style={{ fontSize: '13px', color: theme.textMuted, margin: '0 0 28px' }}>
        Route:{' '}
        <code style={{ color: theme.accent, fontFamily: 'monospace' }}>
          {variant === 'spa' ? '/page-a' : '/page-a/'}
        </code>
      </p>

      <Checklist />
    </div>
  )
}
